import axios from 'axios'

class ClientDocument {
    constructor(apiUrl) {
        this.apiUrl = apiUrl
    }

    /**
     * @author Pedro Ramos
     * @description Handle event to create a new client in A3Cloud
     * @date 20-07-2020
     * @param {String} token
     * @param {Object} clientId
     * @returns {Object}
     * @memberof ClientDocument
     */

    async getClientDocumentA3Cloud(clientId, token, signRequestId) {
        let url = `${this.apiUrl}/clientDocument?clientId=${clientId}`
        if (signRequestId) url = `${this.apiUrl}/clientDocument?clientId=${clientId}&signRequestId=${signRequestId}`

        let response = await axios.get(url,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    }

    /**
      * @author Pedro Ramos
      * @description Crea un clientDocument en la tabla clientDocument de A3cloud
      * @date 29-08-2022
      * @param {Number} clientId
      * @param {Number} documentPersonTypeId
      * @param {String} name
      * @param {String} description
      * @param {Boolean} defaultDocument
      * @param {String} updatedByUser
      * @param {Object} token
      * @returns {Object}
      * @memberof ClientDocumentService
    */
    async createClientDocument(documentForm, token) {

        let response = await axios.post(
            `${this.apiUrl}/clientDocument`,
            documentForm,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },

            }
        );

        return response;
    }

    /**
      * @author Pedro Ramos
      * @description Actualiza un clientDocument en la tabla clientDocument de A3cloud
      * @date 29-08-2022
      * @param {Number} id
      * @param {Number} documentPersonTypeId
      * @param {String} name
      * @param {String} description
      * @param {Boolean} defaultDocument
      * @param {String} updatedByUser
      * @param {Object} token
      * @returns {Object}
      * @memberof ClientDocumentService
    */
    async updateClientDocument(documentForm, token) {
        let response = await axios.put(
            `${this.apiUrl}/clientDocument`,
            documentForm,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },

            }
        );

        return response;
    }

    /**
     * @author Pedro Ramos
     * @description Elimina un clientDocument en la tabla clientDocument de A3cloud
     * @date 29-08-2022
     * @param {Number} id
     * @param {Object} token
     * @returns {Object}
     * @memberof ClientDocumentService
    */
    async deleteClientDocument(documentId, token) {

        let response = await axios.delete(
            `${this.apiUrl}/clientDocument?id=${documentId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response;
    }

    /**
    * @author Edgar Escobedo
    * @description GET all clientDocumentTypeRequest types to documents to require
    * @date 21-08-2024
    * @param {Object} token
    * @returns {Object}
    * @memberof ClientDocumentService
    */
    async getAllClientDocumentTypeRequest(token) {
        let response = await axios.get(
            `${this.apiUrl}/clientDocument-type`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    }

    /**
    * @author Nestor Sandoval
    * @description GET documentos clasificados para llenar la tabla
    * @date 28-01-2026
    * @param {String} token
    * @returns {Object}
    * @memberof ClientDocumentService
    */
    async getClassifiedDocuments(token) {
        let response = await axios.get(
            `${this.apiUrl}/classify-document`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response
    }

    /**
    * @author Nestor Sandoval
    * @description POST para clasificar un documento en grupos específicos
    * @date 28-01-2026
    * @param {Object} classifyData - Datos de clasificación {templateId, groups: [{id, name, value}]}
    * @param {String} token
    * @returns {Object}
    * @memberof ClientDocumentService
    */
    async saveClassifyDocument(classifyData, token) {
        let response = await axios.post(
            `${this.apiUrl}/classify-document`,
            classifyData,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    }

    /**
    * @author Nestor Sandoval
    * @description POST para crear un nuevo grupo
    * @date 28-01-2026
    * @param {Object} groupData - Datos del grupo {name: string, id: null}
    * @param {String} token
    * @returns {Object}
    * @memberof ClientDocumentService
    */
    async createGroup(groupData, token) {
        let response = await axios.post(
            `${this.apiUrl}/group`,
            { group: groupData },
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    }

    /**
    * @author Nestor Sandoval
    * @description POST para crear o actualizar un document template con grupos
    * @date 28-01-2026
    * @param {Object} documentData - {documentId?: number, name: string, description?: string, typeDocumentId?: number, groups: [{id, name, value}]}
    * @param {String} token
    * @returns {Object}
    * @memberof ClientDocumentService
    */
    async createOrUpdateDocumentTemplate(documentData, token) {
        let response = await axios.post(
            `${this.apiUrl}/document-template`,
            documentData,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    }

    /**
    * @author Nestor Sandoval
    * @description DELETE para eliminar un document template por id
    * @date 28-01-2026
    * @param {number} documentId
    * @param {string} token
    * @returns {Object}
    */
    async deleteDocumentTemplate(documentId, token) {
        const response = await axios.delete(
            `${this.apiUrl}/document-template?documentId=${documentId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    }

}

export { ClientDocument as default }